// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2295":"3c111b64","4533":"4ed15606","6310":"c6c1af2b","7650":"feb9faf7","8315":"6e9b785b"}[chunkId] + ".chunk.css";
};